import React, { useEffect, useState } from "react";
import {
  Typography, Divider, Box, TextField, Autocomplete, CircularProgress
} from "@mui/material";
import { STEP4_REQUIRED_FIELDS } from "./AddTalent";
import {
  secteurOptions as secteurFallback,
  contractTypeOptions,
  workEnvironmentOptions
} from "../../../commun/constants/options";
import { parseSecteursExcel } from "../../../commun/autofillExcel";
import DynamicForm from "../../../commun/DynamicForm";
import './Step4Form.css';
import axios from "axios";

function Step4Form({ formData, setFormData, goToPreviousStep, onSubmit, devise, setDevise }) {
  const [errors, setErrors] = useState({});
  const [secteurOptions, setSecteurOptions] = useState([]);
  const [autocompleteOptions, setAutocompleteOptions] = useState([]);
  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
  const contractTypesSelected = formData.typesContrat || [];

  useEffect(() => {
    parseSecteursExcel().then(setSecteurOptions).catch(() => {
      setSecteurOptions(secteurFallback);
    });
  }, []);

  const fetchAutocomplete = async (input) => {
    if (!input || input.length < 2) return;
    setLoadingAutocomplete(true);
    try {
      const res = await axios.get('/api/autocomplete', { params: { input } });
      const suggestions = res.data.predictions.map(p => p.description);
      setAutocompleteOptions(suggestions);
    } catch (err) {
      console.error("Erreur autocomplete :", err);
    } finally {
      setLoadingAutocomplete(false);
    }
  };

  const validateFields = () => {
    const newErrors = {};
    STEP4_REQUIRED_FIELDS.forEach((field) => {
      const value = formData[field];
      if (!value || (Array.isArray(value) && value.length === 0)) {
        newErrors[field] = "Veuillez remplir ce champ";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateFields()) {
      onSubmit();
    }
  };

  const step4Config = [
    { type: "text", label: "Postes recherchés", name: "postesRecherches" },
    { type: "chip-select", label: "Types de contrat", name: "typesContrat", options: contractTypeOptions.map(opt => opt.label), containerClass: "select-small" },
    ...contractTypesSelected.map((type) => ({
      type: "remuneration",
      label: `Rémunération pour ${type}`,
      name: `remunerations.${type}`  
    })),

    { type: "select", label: "Secteur souhaité", name: "secteurRecherche", options: secteurOptions },
    { type: "select", label: "Secteur non souhaité", name: "secteurNonRecherche", options: secteurOptions },
    {
      type: "select",
      label: "Cadre de travail souhaité",
      name: "travailSouhaite",
      options: workEnvironmentOptions.map((opt) => opt.label),
      containerClass: "select-small",
    },
    {
      type: "custom",
      name: "lieuxSouhaites",
      render: () => (
        <Autocomplete
          multiple
          freeSolo
          options={autocompleteOptions}
          loading={loadingAutocomplete}
          value={formData.lieuxSouhaites || []}
          onInputChange={(e, input) => fetchAutocomplete(input)}
          onChange={(e, value) => setFormData((prev) => ({ ...prev, lieuxSouhaites: value }))}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Lieux de travail souhaités"
              fullWidth
              error={!!errors.lieuxSouhaites}
              helperText={errors.lieuxSouhaites}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingAutocomplete && <CircularProgress color="inherit" size={18} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      )
    },
    {
      type: "custom",
      name: "lieuxNonSouhaites",
      render: () => (
        <Autocomplete
          multiple
          freeSolo
          options={autocompleteOptions}
          loading={loadingAutocomplete}
          value={formData.lieuxNonSouhaites || []}
          onInputChange={(e, input) => fetchAutocomplete(input)}
          onChange={(e, value) => setFormData((prev) => ({ ...prev, lieuxNonSouhaites: value }))}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Lieux de travail non souhaités"
              fullWidth
              error={!!errors.lieuxNonSouhaites}
              helperText={errors.lieuxNonSouhaites}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingAutocomplete && <CircularProgress color="inherit" size={18} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      )
    },
    {
      type: "select",
      label: "Ce talent est-il ?",
      name: "etatRecherche",
      options: ["En recherche active", "À l'écoute d’opportunité"],
    },
    // {
    //   type: "radio",
    //   label: "Autres processus de recrutement en cours ?",
    //   name: "autresProcessus",
    //   options: [
    //     { label: "Oui", value: "Oui" },
    //     { label: "Non", value: "Non" },
    //   ],
    // },
  ];

  return (
    <Box className="step4-container">
      <Typography variant="h6" className="step4-title">
        Souhaits professionnels
      </Typography>
      <Divider className="step4-divider" />

      <DynamicForm
        fields={step4Config}
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
        onSubmit={handleSubmit}
        onBack={goToPreviousStep}
        additionalProps={{ devise, setDevise }}
      />
    </Box>
  );
}

export default Step4Form;
